export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    // { label: "状态", prop: "status", slots: "status" },
    { label: "活动ID", prop: "id", width: 100, },
    { label: "活动类型", prop: "title", width: 160, },
    { label: "参与者小程序openid", prop: "openid", width: 160, },
    { label: "参与者手机号", prop: "phone", slots: "phone", width: 160, },
    { label: "视频链接地址", prop: "videoUrl", slots: "videoUrl", width: 300, },
    // { label: "投票内容", prop: "message", slots: "message", width: 160, },
    { label: "选手姓名", prop: "name", width: 160, },
    { label: "参赛宣言", prop: "commit", width: 160, },
    { label: "照片链接地址", prop: "imgUrl", slots: "imgUrl", width: 160, },
    {
      label: "创建日期",
      prop: "createTime",
      width: 180,
    },
    // { label: "会话ID", prop: "answerNumber", slots: "answerNumber", width: 220, },
    {
      label: "操作",
      prop: "operation",
      width: 120,
      slots: "operation",
      fixed: "right",
    },
  ];
}
